<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side.md
          side-nav(
            v-bind:sideNavData="sideNavData"
          )
        .profile-page__main.md
          .profile-page__header
            //.profile-page__title
              h1.title Аналитика
            .profile-page__tabs
              tab-nav(
              v-bind:tabNavData="tabNavData"
              )
            .profile-page__content
              section.form__elem--align-justify.form__elem_full.profile__filter.profile__filter_lg
                .profile__table-filter
                  .simple-select-form
                    .simple-select-form__button Смена
                    //.simple-select-form__list
                      ul
                        li Смена
                        li Смена
                  .simple-select-form
                    .simple-select-form__button Квота
                    //.simple-select-form__list
                      ul
                        li Лагерь
                        li Лагерь
                  .simple-select-form
                    .simple-select-form__button Статус
                    //.simple-select-form__list
                      ul
                        li Лагерь
                        li Лагерь

                .profile__buttons
                  .button.button--download
                  .button.button_paint-main--transparent
                    .button__text Сформировать отчет
          .profile-page__body
            reports-table(
            :tab_data="test"
              :tab_head="testHead")
            .table__pagination
              pagination

    .profile-page__footer.page__footer
      main-footer
</template>
<script>
import {mapState, mapActions} from "vuex";
import {Bar} from "vue-chartjs";

import MainFooter from "@/components/footer/Footer";
import SideNav from "@/components/sideNav/SideNav";
import TabNav from "../../../../components/tabNav/TabNav.vue";
import ReportsTable from "../components/reports-table.vue";
import Pagination from "../../operator/components/Pagination.vue";

export default {
  name: "AnalyticsReports",
  components: {
    Pagination,
    ReportsTable,
    TabNav,
    SideNav,
    MainFooter
  },
  props: ["sideNavData"],
  data() {
    return {
      testHead: [
        {
          title: "ФИО",
          id: 1
        },
        {
          title: "Паспорт серия номер",
          id: 2
        },
        {
          title: "Дата рождения",
          id: 3
        },
        {
          title: "Место рождения",
          id: 4
        },
        {
          title: "Адрес по месту жительства",
          id: 5
        }
      ],
      test: [
        {
          name: "Султанов Рамиль Рустамович",
          passport: "75434 35 53",
          date: "15.09.18",
          place: "Руспублика Татарстан, Казань",
          address: "Рихарда Зорге 46 ",
          id: 1
        },
        {
          name: "Султанов Рамиль Рустамович",
          passport: "75434 35 53",
          date: "15.09.18",
          place: "Руспублика Татарстан, Казань",
          address: "Рихарда Зорге 46 ",
          id: 2
        },
        {
          name: "Султанов Рамиль Рустамович",
          passport: "75434 35 53",
          date: "15.09.18",
          place: "Руспублика Татарстан, Казань",
          address: "Рихарда Зорге 46 ",
          id: 3
        }
      ],
      tabNavData: {
        tabs: [
          {
            path: "/pages/analytics/charts",
            text: "Диаграммы"
          },
          {
            path: "/pages/analytics/reports",
            text: "Отчеты"
          }
        ]
      }
    };
  }
};
</script>
